import { FC, createContext } from 'react';

interface IConfig {
  basename: string;
  locale: string;
}

export interface IConfigContext {
  config: IConfig;
}

export const ConfigContext = createContext<IConfigContext>({
  config: {
    basename: '',
    locale: 'uk',
  },
});

export const ConfigContextProvider: FC<IConfigContext> = ({ config, children }) => {
  return <ConfigContext.Provider value={{ config }}>{children}</ConfigContext.Provider>;
};
